import { addOrRemoveString, CheckboxGroup } from "@cerebruminc/cerebellum";
import { useLocation, useSearch } from "@tanstack/react-router";
import { useAtomValue, useSetAtom } from "jotai";
import { navigateApp } from "src/lib/app-router";
import { availableFiltersAtom } from "src/shame/shame-atoms";
import { UserTableFilterIds } from "../types";
import { TabFormContainer } from "src/components/FiltersModal/TabFormContainer";
import React from "react";
import { forcedTableLoadingAtom } from "src/shame/shame-atoms";
import { normalizeSearchParam, removeQueryParamFromRouter } from "../helpers";

const TAB_ID = UserTableFilterIds.Organization;

export function OrganizationsForm({ allFilters }: { allFilters: any }) {
	const availableFilters = useAtomValue(availableFiltersAtom);
	const setForcedTableLoading = useSetAtom(forcedTableLoadingAtom);
	const location = useLocation();
	const search = useSearch({ strict: false }) as Record<string, unknown>;

	const typeCheckedFilters = normalizeSearchParam(search[TAB_ID]);

	const noActiveFilters = typeCheckedFilters?.length === 0;

	return (
		<TabFormContainer allFilters={allFilters} tabId={TAB_ID} title="Organizations" noActiveFilters={noActiveFilters}>
			<CheckboxGroup
				wrapText={true}
				activeValues={typeCheckedFilters}
				checkboxes={availableFilters?.organizations?.map((item) => ({
					label: item.label,
					value: item.id,
				}))}
				label=" "
				name={TAB_ID}
				onClick={(event) => {
					setForcedTableLoading(true);
					const newValue = addOrRemoveString({
						array: normalizeSearchParam(search.organizations),
						string: event.target.value,
					});
					if (newValue.length) {
						navigateApp({
							search: { ...search, organizations: newValue },
							to: location.pathname,
						});
					} else {
						removeQueryParamFromRouter({ paramKey: "organizations", pathname: location.pathname, search });
					}
				}}
			/>
		</TabFormContainer>
	);
}
